import * as React from "react";
import { CalendarClock, ChartLine, MessageSquareHeart } from "lucide-react";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
const features = [{
  title: "Clases de apoyo",
  description: "Nos adaptados a todos los niveles y edades.",
  icon: MessageSquareHeart
}, {
  title: "Apoyo Académico",
  description: "Refuerzo escolar personalizado para primaria, secundaria y bachillerato. Mejoramos tus resultados con técnicas de estudio eficaces.",
  icon: CalendarClock
}, {
  title: "Preparación de Exámenes",
  description: "Cursos intensivos para preparar exámenes y así asegurar tu éxito académico.",
  icon: ChartLine
}];
export default function PracticeManagementReimagined() {
  return <section data-section-id="223262" id="nuestra-oferta-educativa" className="bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden relative">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 rounded-lg blur-[100px] pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold font-default mb-6 tracking-tight text-foreground">
            Nuestra Oferta Educativa
          </h2>
          <p className="text-lg text-muted-foreground font-default">Impulsa tu talento, supera cada nivel. En Centro de Estudios Cosmos, diseñamos tu camino al éxito en un entorno diseñado para ti.</p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: false
      }} className="w-full">
          <CarouselContent className="flex-col gap-6 ml-0">
            {features.map((feature, i) => <CarouselItem key={i} data-index={i} className="w-full pl-0">
                <Card className="h-full bg-white backdrop-blur-none border-border transition-all duration-300 hover:-translate-y-2 hover:shadow-lg hover:shadow-black/5 hover:border-primary/20 rounded-xl group">
                  <CardHeader className="p-8">
                    <div className="size-14 rounded-xl bg-transparent flex items-center justify-center mb-6 transition-colors duration-300">
                      <feature.icon className="size-10 text-primary" />
                    </div>
                    <CardTitle className="font-default font-bold text-2xl mb-3 text-foreground">
                      {feature.title}
                    </CardTitle>
                    <CardDescription className="text-base leading-relaxed text-muted-foreground font-default">
                      {feature.description}
                    </CardDescription>
                    <div className="mt-6 flex justify-end">
                      
                    </div>
                  </CardHeader>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
        </Carousel>
      </div>
    </section>;
}